import request from 'tools/request'

export const getUnderwritersScoreHeaders = async (carrierId: string) => {
  const res = await request.get(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}underwriters-score/${carrierId}/headers`
  )
  return res?.data
}

export const getUnderwritersScoreRiskScore = async (carrierId: string) => {
  const res = await request.get(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}underwriters-score/${carrierId}/risk-score`
  )
  return res?.data
}

